import React from "react";
import Select from "react-select";
import {
  customSelectStyles,
  getOrganizationId,
} from "../../../../../Utils/CommonUtils";
import { userProductMappingAction } from "../UserService";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setProductMappingData } from "../../../../../slices/team/users/usersSlice";

const SelectDropdownProductMapping = ({ selectedRows }) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.users.selectedUser.detailsData);
  const productMappingData = useSelector(
    (state) => state.users.selectedUser.productMappingData
  );
  const ownerId = getOrganizationId();
  const selectOptions = [
    { label: "Linked", value: "linked", action_flag: 1 },
    { label: "Unlinked", value: "unlinked", action_flag: 0 },
  ];

  const handleStatusChange = (selectedOption) => {
    if (
      !productMappingData ||
      productMappingData.length === 0 ||
      !selectedRows ||
      selectedRows.length === 0
    ) {
      return;
    }

    // Filter productMappingData based on selectedRows
    const updatedEntities = productMappingData
      .filter((row) => selectedRows.includes(row.entityid))
      .map((row) => ({
        ...row,
        linked_status: selectedOption.value,
      }));

    // Extract entity_ids from updatedEntities
    const entityIdsToUpdate = updatedEntities.map((entity) => entity.entityid);
    const action_flag =
      selectOptions.find((option) => option.value === selectedOption.value)
        ?.action_flag ?? 0;

    // Call userProductMappingAction with entityIdsToUpdate
    userProductMappingAction(
      data.entityid,
      entityIdsToUpdate,
      action_flag,
      setProductMappingData
    );
  };

  return (
    <Select
      placeholder="Link"
      name="name"
      options={selectOptions}
      styles={customSelectStyles}
      onChange={handleStatusChange}
      menuPortalTarget={document.body}
      required
    />
  );
};

export default SelectDropdownProductMapping;
